import React, { FunctionComponent } from "react";
import BaseCard, { BaseCardProps } from "../base";
import CardVerticalLayout from "./CardVerticalLayout";

export type CardBasicVerticalType = Omit<
  BaseCardProps,
  "layout" | "renderLayout"
>;

export const CardBasicVertical: FunctionComponent<CardBasicVerticalType> = (props) => {
  return (
    <BaseCard
      {...props}
      layout="vertical"
      renderLayout={(renderProps) => <CardVerticalLayout {...renderProps} />}
    />
  );
};

export default CardBasicVertical;
